import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "reset_password_modal",
  tabindex: "-1",
  "aria-hidden": "true",
  ref: "resetPasswordModalRef"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "modal-header",
  id: "reset_password_modal_header"
}, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Reset Password")
], -1)
const _hoisted_5 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_6 = {
  class: "scroll-y me-n7 pe-7",
  id: "reset_password_modal_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#reset_password_modal_header",
  "data-kt-scroll-wrappers": "#reset_password_modal_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_7 = { class: "fv-row mb-7" }
const _hoisted_8 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_9 = { class: "required" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "fv-row mb-7" }
const _hoisted_13 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_14 = { class: "fv-plugins-message-container" }
const _hoisted_15 = { class: "fv-help-block" }
const _hoisted_16 = { class: "modal-footer flex-end" }
const _hoisted_17 = ["data-kt-indicator"]
const _hoisted_18 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_19 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_20 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_Form, {
          id: "kt_change_password",
          class: "form",
          novalidate: "novalidate",
          onSubmit: _ctx.submit,
          "validation-schema": _ctx.changePassword
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.translate("EDIT_PASSWORD_MODAL_NEW_PASSWORD_LABEL")), 1)
                  ]),
                  _createVNode(_component_Field, {
                    type: "password",
                    class: "form-control form-control-lg fw-bold fs-6",
                    name: "newpassword",
                    id: "newpassword"
                  }),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_ErrorMessage, { name: "newpassword" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.translate("EDIT_PASSWORD_MODAL_NEW_PASSWORD_CONFIRMATION_LABEL")), 1),
                  _createVNode(_component_Field, {
                    type: "password",
                    class: "form-control form-control-lg fw-bold fs-6",
                    name: "confirmpassword",
                    id: "confirmpassword"
                  }),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_ErrorMessage, { name: "confirmpassword" })
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("button", {
                type: "button",
                id: "reset_password_modal_cancel",
                "data-bs-dismiss": "modal",
                class: "btn btn-white",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
              }, _toDisplayString(_ctx.translate("BUTTON_CLOSE")), 1),
              _createElementVNode("button", {
                "data-kt-indicator": _ctx.loading ? 'on' : null,
                class: "btn btn-dark-blue",
                type: "submit"
              }, [
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                      _createTextVNode(_toDisplayString(_ctx.translate("BUTTON_SUBMIT")) + " ", 1),
                      _createElementVNode("span", _hoisted_19, [
                        _createVNode(_component_inline_svg, {
                          src: "icons/duotune/arrows/arr064.svg",
                          "aria-hidden": "true"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                      _createTextVNode(" Please wait... "),
                      _hoisted_21
                    ]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_17)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ])
  ], 512))
}